const doesUserTicketExist = (userId, userTickets) => {
  return userTickets?.some((ticket) => ticket.userId === userId);
};

export const fetchTicketHelper = {
  doesUserTicketExist
};
